import { MetamodelComponentTypeStyle } from '@ardoq/api-types';
import {
  ComponentDecoratorAsTag,
  getComponentRepresentationDataWithTagColors,
} from '@ardoq/basic-components';
import { InteractiveComponentDecoratorAsTag } from '@ardoq/decorators';
import { KeyboardEventHandler } from 'react';

export type ComponentTagProps = {
  name: string;
  style: MetamodelComponentTypeStyle;
  showComponentOverviewDrawer?: VoidFunction;
  onCloseClick?: VoidFunction;
  onBackspaceClick?: KeyboardEventHandler<HTMLElement>;
};

export const ComponentTag = ({
  name,
  style: { level, icon, image, color },
  showComponentOverviewDrawer,
  onCloseClick,
  onBackspaceClick,
}: ComponentTagProps) => {
  const representationData = getComponentRepresentationDataWithTagColors({
    level: level ?? 0,
    icon: icon ?? null,
    image: image ?? null,
    color: color ?? null,
  });

  if (showComponentOverviewDrawer) {
    return (
      <InteractiveComponentDecoratorAsTag
        shadedColor={representationData.shadedColor}
        lightenedColor={representationData.lightenedColor}
        contrastColor={representationData.contrastColor}
        icon={representationData.icon}
        value={representationData.value}
        isImage={representationData.isImage}
        label={name}
        title={name}
        noMargin
        onClick={showComponentOverviewDrawer}
        onCloseClick={onCloseClick}
        onKeyDown={onBackspaceClick}
      />
    );
  }

  return (
    <ComponentDecoratorAsTag
      shadedColor={representationData.shadedColor}
      lightenedColor={representationData.lightenedColor}
      contrastColor={representationData.contrastColor}
      icon={representationData.icon}
      value={representationData.value}
      isImage={representationData.isImage}
      label={name}
      noMargin
    />
  );
};
